import React from "react";
import { Container, Row, Card, Badge } from "react-bootstrap";
function Categories(props) {
  if (props.from === "form" && props.spcl === "issub") {
    return (
      <div className="cat-div-32" key={props.id}>
        <a
          onClick={() => props.func(props.id)}
          className=" text-dark updatePro-Btn-Modal"
          key={props.id}
        >
          <div className="cat-div-32-img-cntn">
            <div className="cat-div-32-img-cntn-2">
              <img
                src={"https://s3.toolsvilla.com/" + props.image}
                className="w-100 h-100"
              ></img>
            </div>
          </div>
          <p class="fs-13 theme-col pt-2 f-600 text-center">
            {props.subName}{" "}
            <i class="bi bi-arrow-right-circle-fill mx-2 link-primary"></i>
          </p>
        </a>
        {" "}
      </div>
    );
  } else if (props.from === "form" && props.spcl === "finalcat") {
    return (
      <div
        className="cat-div-32"
        key={props.id}
        onClick={() => props.func(props.id)}
      >
        <a className=" text-dark updatePro-Btn-Modal" key={props.id}>
          <div className="cat-div-32-img-cntn">
            <div className="cat-div-32-img-cntn-2">
              <img
                src={"https://d18hmorleaqjq7.cloudfront.net/" + props.image}
                className="w-100 h-100"
              ></img>
            </div>
          </div>
          <p class="fs-13 theme-col pt-2 f-600 text-center">
            {props.subName}{" "}
            {props.applied ? (
              <Badge bg="success" className="mx-1">
                <i class="bi bi-check-circle"></i> Applied
              </Badge>
            ) : (
              <Badge bg="primary" className="mx-1">
                Apply
              </Badge>
            )}
          </p>
        </a>
        {" "}
      </div>
    );
  } else {
    return (
      <div className="cat-div-32" key={props.id}>
        <a
          onClick={() => props.func(props.id)}
          className=" text-dark updatePro-Btn-Modal"
          key={props.id}
        >
          <div className="cat-div-32-img-cntn">
            <div className="cat-div-32-img-cntn-2">
              <img
                src={"https://s3.toolsvilla.com/" + props.image}
                className="w-100 h-100"
              ></img>
            </div>
          </div>
          <p class="fs-13 theme-col pt-2 f-600 text-center">{props.subName}</p>


        </a>
        {" "}
      </div>
    );
  }
}

export default Categories;
